import { map, uniq } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../../modules/infra/i18n';
import Money from '../../../../common/money';

const TaxCell = ({ value }) => (
  <>
    {value.map((tax) => (
      <React.Fragment key={tax}>
        {tax} <br />
      </React.Fragment>
    ))}
  </>
);

TaxCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const columns = {
  name: {
    Header: () => t('products:products_table.name'),
    accessor: 'name',
  },
  price: {
    Header: () => t('products:products_table.price'),
    accessor: 'price',
    Cell: ({ value }) => <Money>{value}</Money>, // eslint-disable-line react/prop-types
  },
  supplyPrice: {
    Header: () => t('products:products_table.supply_price'),
    accessor: 'supplyPrice',
    Cell: ({ value }) => <Money>{value}</Money>, // eslint-disable-line react/prop-types
  },
  shops: {
    Header: () => t('products:products_table.shops'),
    id: 'shops',
    accessor: (data) => {
      const { assignments = [] } = data;
      const shopText =
        assignments.length === 1
          ? t('products:products_table.shop_singular')
          : t('products:products_table.shop_plural');
      return `${assignments.length} ${shopText}`;
    },
  },
  inventory: {
    Header: () => t('products:products_table.current_inv'),
    accessor: 'inventory',
  },
  totalInventory: {
    Header: () => t('products:products_table.total_inv'),
    id: 'totalInventory',
    accessor: 'totalInventory',
  },
  unallocatedInventory: {
    Header: () => t('products:products_table.unallocated_inv'),
    accessor: 'inventory',
  },
  lowInventory: {
    Header: () => t('products:products_table.low_inv'),
    id: 'lowInventoryThreshold',
    accessor: (data) => {
      const { assignments, lowInventoryThreshold } = data;
      const variants = uniq([lowInventoryThreshold, ...map(assignments || [], (shop) => shop.lowInventoryThreshold)]);
      return variants.length > 1 ? t('products:products_table.varies') : variants[0];
    },
  },
  highInventory: {
    Header: () => t('products:products_table.high_inv'),
    id: 'highInventoryThreshold',
    accessor: (data) => {
      const { assignments, highInventoryThreshold } = data;
      const variants = uniq([highInventoryThreshold, ...map(assignments || [], (shop) => shop.highInventoryThreshold)]);
      return variants.length > 1 ? t('products:products_table.varies') : variants[0];
    },
  },
  sku: {
    Header: () => t('products:products_table.sku'),
    accessor: 'sku',
  },
  tax: {
    Header: () => t('products:products_table.tax'),
    accessor: 'tax',
    Cell: TaxCell,
  },
  category: {
    Header: () => t('products:products_table.category'),
    accessor: 'category',
  },
  brand: {
    Header: () => t('products:products_table.brand'),
    accessor: 'brand',
  },
};

export default columns;
